import { Component, OnInit, Output, EventEmitter, Input, AfterContentInit, Pipe, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms'
import { DomSanitizer } from "@angular/platform-browser";
import { ResellerModel } from '@models/index';
import { emptyResellerModel } from '@utilities/data-utils'
import * as EmailValidator from 'email-validator';
import { NgxPermissionsService } from 'ngx-permissions';
import { NEVER, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-reseller-form',
  templateUrl: './reseller-form.component.html',
  styleUrls: ['./reseller-form.component.sass']
})

export class ResellerFormComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild('imagePublicInput', { static: true }) imagePublicInput: ElementRef;
  @Output() createReseller = new EventEmitter<ResellerModel>();
  @Output() editResellerByReseller = new EventEmitter<ResellerModel>();
  @Output() cancel = new EventEmitter();
  @Input() reseller: ResellerModel;
  @Input() currentReseller$: Observable<ResellerModel>;
  @Input() create: boolean;

  resellerForm: FormGroup;
  emptyReseller = emptyResellerModel();
  initialImage: string = null;
  permissions: any;
  _subs: Subscription = NEVER.subscribe();

  constructor(
    private fb: FormBuilder,
    public sanitizer: DomSanitizer,
    private permissionsService: NgxPermissionsService
  ) { }
  ngOnInit() {
    this.permissions = this.permissionsService.getPermissions()
  }

  ngAfterContentInit() {
    this.resellerForm = this.fb.group({
      name: [this.reseller.name, [Validators.required, this.ValidateName]],
      siteURL: [this.reseller.siteURL, [Validators.required, this.ValidateSiteUrl]],
      favIcon: this.reseller.favIcon,
      availableLicenses: [this.reseller.availableLicenses, [Validators.required]]
    });
    this._subs.add(
      this.currentReseller$
        .subscribe(item => {
          this.reseller = item
          this.initialImage = item.logo
          this.resellerForm.patchValue({
            name: this.reseller.name,
            siteURL: this.reseller.siteURL,
            favIcon: this.reseller.favIcon,
            availableLicenses: this.reseller.availableLicenses
          })
        })
    )
  }

  onSubmit() {
    const reseller = {
      ...this.reseller,
      ...this.resellerForm.value
    };

    if (this.permissions.addResellers) {
      this.createReseller.emit(reseller);
    } else {
      this.editResellerByReseller.emit(reseller);
    }
  }

  imageChanged(image: string): void {
    this.reseller = { ...this.reseller, logo: image ? image : '' };
  }

  uploadFavIcon(target: HTMLInputElement) {
    if (target.files && target.files[0]) {
      let reader = new FileReader();
      reader.onload = ($event: ProgressEvent) => {
        this.reseller = { ...this.reseller, favIcon: (<FileReader>$event.target).result.toString() };
        this.resellerForm.patchValue({
          favIcon: (<FileReader>$event.target).result.toString()
        })
      }
      reader.readAsDataURL(target.files[0]);
      const imageName = `photo-${Date.now()}.ico`
      const file = new File([target.files[0]], imageName, { type: "image/ico" })
      target.value = "";
    }
  }

  removeFavIcon() {
    this.resellerForm.patchValue({
      favIcon: this.emptyReseller.favIcon
    })
  }

  ValidateName(control: AbstractControl) {
    if (control.value && control.value.trim().length) {
      return null;
    }
    return { invalid: true };
  }

  ValidateSiteUrl(control: AbstractControl) {
    if (control.value && control.value.trim().length) {
      return null;
    }
    return { invalid: true };
  }
  ngOnDestroy(): void {
    if (this._subs) this._subs.unsubscribe()
    this.initialImage = null
  }
}
